import { memo } from "react";

import type { AvatarProps } from "@braintrust/braintrust-ui-components";
import { Avatar } from "@braintrust/braintrust-ui-components";
import {
  Box,
  CircularProgressDecorator,
} from "@braintrust/braintrust-ui-components";
import { isPublicBidWithoutUser } from "@js/apps/jobs/apps/bids/helpers";
import type { EmployerBidListBid } from "@js/types/jobs";

import { getResumeMatchMeta } from "../resume-match-summary/helpers";

import styles from "./styles.module.scss";

type BidAvatarWithScoreMatchProps = {
  bid: EmployerBidListBid;
  avatarTextSize?: AvatarProps["textSize"];
  avatarTextVariant?: AvatarProps["textVariant"];
  jobRoleName: string;
};

export const BidAvatarWithScoreMatch = memo(
  ({
    bid,
    avatarTextSize,
    avatarTextVariant,
    jobRoleName,
  }: BidAvatarWithScoreMatchProps) => {
    const matchScore = bid.resume_smart_matching?.match_score;
    const { circularProgressMeta } = getResumeMatchMeta({
      matchScore,
      jobRoleName,
      recommendedByMatcher: bid.recommended_by_matcher,
    });
    const { color, value } = circularProgressMeta;

    const isPublicBid = isPublicBidWithoutUser(bid);
    return (
      <Box className={styles.container}>
        <CircularProgressDecorator
          value={value}
          color={color}
          thickness={2.5}
          sx={{ width: "100%", height: "100%", overflow: "hidden" }}
        >
          <Box
            sx={{
              borderRadius: "50%",
              padding: "2.5px",
              height: "100%",
              width: "100%",
            }}
          >
            <Avatar
              src={bid.freelancer.user}
              size={"full"}
              textSize={avatarTextSize}
              textVariant={avatarTextVariant}
              sx={{
                bgcolor: isPublicBid ? "var(--grey-5) !important" : undefined,
                color: isPublicBid ? "var(--grey-2) !important" : undefined,
              }}
            />
          </Box>
        </CircularProgressDecorator>
      </Box>
    );
  },
);
